import React, { useEffect } from "react";
import { Box, Button, SxProps } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useBrowserBack } from "../../context/BrowserBack";
import { useLocation, useNavigate } from "react-router-dom";

export default function BackButton({
  title,
  globalNavigate = false,
  to,
  sx,
}: {
  title: string;
  globalNavigate?: boolean;
  to?: string;
  sx?: SxProps;
}) {
  const { setNavigateTo, handleBack } = useBrowserBack();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (globalNavigate && to) {
      setNavigateTo(to);
    }

    return () => {
      setNavigateTo(null);
    };
  }, [globalNavigate, to]);

  const handleBackButtonClick = () => {
    if (to && !globalNavigate) {
      navigate(to, { state: location.state });
    } else {
      handleBack();
    }
  };

  return (
    <Box sx={{ width: "80vw", mx: "auto", my: 2, ...sx }}>
      <Button startIcon={<ArrowBack />} onClick={handleBackButtonClick}>
        {title}
      </Button>
    </Box>
  );
}
